import { memo, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { Button } from '@mui/material'

import { useGetOrderQuery } from '@/app/services/orders'
import { selectOrganisationId } from '@/app/slices/organisationSlice'
import AppToolbar from '@/common/components/AppBar/AppToolbar'
import { ORDER_STATUS_ARRAY, Paths } from '@/common/utils'
import DownloadDocuments from '@/features/order/components/DownloadDocuments/DownloadDocuments'

const OrderToolbar = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()
    const { orderId } = useParams()

    const organisationId = useSelector(selectOrganisationId)

    const { data: order, isFetching, isLoading } = useGetOrderQuery({ organisationId, orderId })

    const isDownloadDocumentsEnabled = useMemo(() => {
        return [
            ORDER_STATUS_ARRAY.Issued,
            ORDER_STATUS_ARRAY.Ordered,
            ORDER_STATUS_ARRAY.Invoiced,
            ORDER_STATUS_ARRAY.Cancelled,
            ORDER_STATUS_ARRAY.PendingOrderConfirmation,
        ].includes(order?.status)
    }, [order?.status])

    const handlePlaceOrderClick = () => {
        navigate(Paths.HOME_PATHNAME)
    }

    return (
        <AppToolbar>
            {isDownloadDocumentsEnabled ? (
                <DownloadDocuments
                    data-testid="documents-button"
                    disabled={isLoading || isFetching}
                    order={order}
                    sx={undefined}
                    disableElevation
                />
            ) : null}

            <Button
                color="primary"
                data-testid="place-new-order-button"
                variant="contained"
                onClick={handlePlaceOrderClick}
            >
                {t('Place new order')}
            </Button>
        </AppToolbar>
    )
}

OrderToolbar.propTypes = {}

export default memo(OrderToolbar)
